function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Mail_logo",
  "data-name": "Mail logo",
  transform: "translate(0.05 0.05)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1068",
  "data-name": "Path 1068",
  d: "M62.749-76.765,42.624-85.913a.964.964,0,0,0-.8,0L21.7-76.765A2.9,2.9,0,0,0,20-74.126v24.845a2.9,2.9,0,0,0,2.9,2.9H61.55a2.9,2.9,0,0,0,2.9-2.9V-74.126A2.9,2.9,0,0,0,62.749-76.765Z",
  transform: "translate(-20 91.233)",
  fill: "#034fa0",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_45",
  "data-name": "Rectangle 45",
  d: "M2,0H30.516a2,2,0,0,1,2,2V31.4a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
  transform: "translate(5.606 0)",
  fill: "#249ee4",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1069",
  "data-name": "Path 1069",
  d: "M63.962-71.873a.974.974,0,0,0-.971.008L42.224-59.595,21.458-71.866a.974.974,0,0,0-.971-.008.968.968,0,0,0-.487.84v22.224a2.9,2.9,0,0,0,2.9,2.9H61.55a2.9,2.9,0,0,0,2.9-2.9V-71.034A.968.968,0,0,0,63.962-71.873Z",
  transform: "translate(-20 90.761)",
  fill: "#0078d4",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1070",
  "data-name": "Path 1070",
  d: "M61.55-45.592a2.9,2.9,0,0,0,2.9-2.9v-.994L47.787-62.563l-5.563,3.286-5.563-3.286L20-49.485v.994a2.9,2.9,0,0,0,2.9,2.9Z",
  transform: "translate(-20 90.443)",
  fill: "#034fa0",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1071",
  "data-name": "Path 1071",
  d: "M63.459-47.871,43.434-63.588a1.916,1.916,0,0,0-2.375,0L21.034-47.871a.965.965,0,0,0-.369.726.963.963,0,0,0,.317.751,2.889,2.889,0,0,0,1.939.754H61.572a2.889,2.889,0,0,0,1.939-.754.963.963,0,0,0,.317-.751A.965.965,0,0,0,63.459-47.871Z",
  transform: "translate(-20.022 90.491)",
  fill: "#0078d4",
  stroke: "#fff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_75",
  "data-name": "Group 75",
  transform: "translate(13.528 7.166)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1072",
  "data-name": "Path 1072",
  d: "M42.7-82.067h-7.73A.967.967,0,0,1,34-83.034.967.967,0,0,1,34.966-84H42.7a.967.967,0,0,1,.966.966A.967.967,0,0,1,42.7-82.067Z",
  transform: "translate(-34 84)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_76",
  "data-name": "Group 76",
  transform: "translate(13.528 16.828)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1073",
  "data-name": "Path 1073",
  d: "M46.562-72.067h-11.6A.967.967,0,0,1,34-73.034.967.967,0,0,1,34.966-74h11.6a.967.967,0,0,1,.966.966A.967.967,0,0,1,46.562-72.067Z",
  transform: "translate(-34 74)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_77",
  "data-name": "Group 77",
  transform: "translate(13.528 11.997)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1074",
  "data-name": "Path 1074",
  d: "M50.427-77.067H34.966A.967.967,0,0,1,34-78.034.967.967,0,0,1,34.966-79h15.46a.967.967,0,0,1,.966.966A.967.967,0,0,1,50.427-77.067Z",
  transform: "translate(-34 79)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.1
})));

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.549,
    height: 44.95,
    viewBox: "0 0 44.549 44.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.6ad1cc8c.svg";
export { ForwardRef as ReactComponent };